<style scoped lang="scss" type="text/scss">
    .wrap-container {
        display: flex;
        flex-wrap: wrap;
        margin: -.5rem -.5rem 0 0;

        .ticket-item {
            margin: .5rem .5rem 0 0;
        }

        .placeholder {
            margin: .5rem .5rem 0 0;
        }
    }
</style>

<template>
    <div class="wrap-container">
        <ticket class="ticket-item" v-for="(item, index) in data" :key="index" :role="item.personal_role"
                :gender="item.personal_gender">
            {{item.personal_name}}
        </ticket>
        <placeholder v-if="data.length === 0" class="placeholder">
            未推荐解说员
        </placeholder>
    </div>
</template>

<script>
    import Ticket from '@/components/ticket/index';
    import Placeholder from '@/components/placeholder/index';

    export default {
        name: '',
        props: {
            data: {
                type: Array,
                default: () => []
            }
        },
        components: {
            Ticket,
            Placeholder
        },
        data () {
            return {};
        }
    };
</script>
